var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.372,
    height: 37.372,
    rx: 18.686,
    fill: "#fff",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.035 19.367a9.3 9.3 0 0 0-.127-1.517h-7.552v3.013h4.324a3.723 3.723 0 0 1-1.604 2.393v2.005h2.58c1.51-1.397 2.379-3.455 2.379-5.894Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.356 27.205c2.165 0 3.976-.721 5.3-1.944l-2.58-2.005c-.722.481-1.637.775-2.72.775-2.091 0-3.863-1.41-4.497-3.315h-2.66v2.065a8.007 8.007 0 0 0 7.157 4.424Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.859 20.716a4.653 4.653 0 0 1-.254-1.53c0-.535.093-1.05.254-1.53V15.59h-2.66a7.926 7.926 0 0 0 0 7.19l2.66-2.064Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.356 14.341c1.183 0 2.239.408 3.074 1.203l2.286-2.285c-1.384-1.297-3.195-2.092-5.36-2.092A8.007 8.007 0 0 0 12.2 15.59l2.66 2.065c.634-1.905 2.406-3.315 4.497-3.315Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.a7af091761f70ce45ce256b40cd86151.svg";
export { ForwardRef as ReactComponent };